import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify'
import Dropdown from '../components/Dropdown';
import { getPoByOrderId, getPrintingPo, getRtvPo, getRtvPoWithParams, Innovent_Path, PathCustom, reqInstance } from '../Path/Path';

import { ibtData } from './StaticData/IBT';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Loader from '../components/Loader';
import { Autocomplete, TextField } from '@mui/material';
import { GrDocumentCsv } from 'react-icons/gr';
import moment from 'moment/moment';
import { CSVLink } from 'react-csv';
import axios from 'axios';


const AsnCancelation = () => {
    const [poList, setPoList] = useState([])
    const [poData, setPoData] = useState([])
    const [poDataList, setPoDataList] = useState([])
    const [invoiceList, setInvoiceList] = useState([])
    const [ibtData, setIbtData] = useState([])
    const [ibtDataFilter, setIbtDataFilter] = useState([])
    const [tableData, setTableData] = useState({})
    const [poNumberVal, setpoNumberVal] = useState('')
    const [run, setRun] = useState(false)
    const [loading, setLoading] = useState(false)

    const [toDate, setToDate] = useState(null)
    const [fromDate, setFromDate] = useState(null)
    const [source, setSource] = useState('')
    const [destination, setDestination] = useState('')
    const [invoiceNumberVal, setinvoiceNumberVal] = useState('')
    const [filters, setFitlers] = useState({})
    useEffect(() => {
        // 
    }, []);
    useEffect(() => {
        async function fetchData(toDate, fromDate, asn) {
            setLoading(true)
            const getPo = await getRtvPo()
                .then((async res => {
                    setLoading(false)
                    await setIbtData(res.data)
                    await setIbtDataFilter(res.data);

                }))
                .catch((err => {
                    toast.error('Something Went Wrong')
                    setLoading(false)
                }))

            // let uniqueArray = []
            // uniqueArray = ibtData?.filter(function (item, pos) {
            //     return ibtData.indexOf(item) == pos;
            // })




        }
        fetchData();

    }, []);
    async function fetchDataWithParams() {
        setLoading(true)
        function replaceAll(str, find, replace) {
            return str?.replace(new RegExp(find, 'g'), replace);
        }
        console.log(toDate);
        console.log(fromDate);
        const getPo = await getRtvPoWithParams({ toDate: replaceAll(formatDateReverse(toDate), '-', '/'), fromDate: replaceAll(formatDateReverse(fromDate), '-', '/'), asn: invoiceNumberVal })
            .then((async res => {
                setLoading(false)
                await setIbtData(res.data)
            }))
            .catch((err => {
                toast.error('Something Went Wrong')
                setLoading(false)
            }))
        console.log(getPo.data);
    }
    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
        // return console.log([year, month, day].join('-'))
    }
    const formatDateReverse = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = month;
        if (day.length < 2)
            day = day;

        return [month, day, year].join('-');
        // return console.log([year, month, day].join('-'))
    }
    const dateFilter = () => {
        ibtDataFilter.map((item => console.log(item.source)))
        ibtDataFilter.map((item => console.log(item.ASN)))
        ibtDataFilter.map((item => console.log(item.destination)))
        if (toDate === null && toDate === null) {
            return ibtDataFilter.filter((x =>
                x?.ASN?.toLowerCase().includes(invoiceNumberVal.toLowerCase())
                &&
                x?.source?.toLowerCase().includes(source.toLowerCase())
                &&
                x?.destination?.toLowerCase().includes(destination.toLowerCase())
            ))
        } else {
            return ibtDataFilter.filter((x =>
                formatDate(x?.packing_date) >= formatDate(toDate) && formatDate(x?.packing_date) <= formatDate(fromDate)
                ||
                formatDate(x?.shipping_date) >= formatDate(toDate) && formatDate(x?.shipping_date) <= formatDate(fromDate)
                ||
                formatDate(x?.receiving_date) >= formatDate(toDate) && formatDate(x?.receiving_date) <= formatDate(fromDate)
                &&
                x?.ASN?.toLowerCase().includes(invoiceNumberVal.toLowerCase())
                &&
                x?.source?.toLowerCase().includes(source.toLowerCase())
                &&
                x?.destination?.toLowerCase().includes(destination.toLowerCase())
            ))
        }

    }
    const searchData = () => {
        setIbtData(dateFilter())
        console.log(dateFilter());

    }
    const headers = [
        { label: "ASN", key: 'ASN' },
        { label: "Source", key: 'source' },
        { label: "Destination", key: 'destination' },
        { label: "Packed Qty", key: 'packedQTY' },
        { label: "Transfer Qty", key: 'tanfersQTY' },
        { label: "Received Qty", key: 'RecievedQTY' },
        { label: "Status", key: 'status' },
        { label: "Packing Date", key: 'packing_date' },
        { label: "Shipping Date", key: 'shipping_date' },
        { label: "Receiveing Date", key: 'receiving_date' },
        { label: "Packing Remarks", key: 'packing_remarks' },
        { label: "Receiving Remarks Remarks", key: 'receiving_remarks' },
        { label: "Shipping Remarks", key: 'shipping_remarks' },
    ]
    const csvData = ibtData.map((item => {
        return {
            ASN: item?.ASN || '----',
            source: item?.source || '----',
            destination: item?.destination || '----',
            packedQTY: item?.items?.filter((item => item.process_status === 'packed')).length || '----',
            tanfersQTY: item?.items?.filter((item => item.process_status === 'shipped')).length || '----',
            RecievedQTY: item?.items?.filter((item => item.process_status === 'received')).length || '----',
            status: item?.event_ref_id?.endsWith('01') ? 'packing' : item?.event_ref_id?.endsWith('02') ? 'shipping' : 'receiving' || '----',
            packing_date: item?.packing_date || '----',
            shipping_date: item?.shipping_date || '----',
            receiving_date: item?.receiving_date || '----',
            packing_remarks: item?.packing_remarks || '----',
            receiving_remarks: item?.receiving_remarks || '----',
            shipping_remarks: item?.shipping_remarks || '----',
        }
    }))
    //         source
    // destination
    // packing_date
    // shipping_date
    // receiving_date
    // packing_remarks
    // recieveing_remarks
    // shipping_remarks

    const deleteHandler = async (item) => {
        const bodyFlow = {
            "ASN": `${item?.po_number}|${item?.invoice_number}`
        }
        const body = {
            "po_number": item?.po_number,
            "invoice_number": item?.invoice_number
        }
        await reqInstance.post(`${Innovent_Path}api/cancel-po-invoice`, bodyFlow)
            .then((async res => {
                console.log(res, 'res');
                toast.success("ASN deleted ")
                await axios.post(`${PathCustom}store/DeletePo`, body)
            })).catch((err => {
                // console.log(, 'res');
                if (err?.message === 'Request failed with status code 400') {

                    return toast.error("Unable to cancel a received Invoice")
                }
            }))

        // console.log(deleted, 'deleted');
    }
    return (
        <>
            <Loader loading={loading} />
            <iframe id="printf" name="printf" style={{ display: 'none' }} ></iframe>
            <div className='dashboard-main'>
                <div className='dashboard-top' style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <p className='stock-count' style={{ fontSize: '25px', margin: 0 }}>Asn Cancelation</p>
                        <CSVLink
                            filename='SupplyChain/PO'
                            data={csvData}
                            headers={headers}
                        >
                            <GrDocumentCsv color='white' fill='white' fontSize={25} style={{ marginRight: 5, cursor: 'pointer' }} />

                        </CSVLink>

                    </div>
                    <div>
                        <h1 style={{ color: 'black', fontSize: '15px' }}>
                            {new Date().toLocaleString('hi-IN')}
                        </h1>
                    </div>


                </div>
                <div className='dashboard-bottom' style={{ marginTop: "0.5%" }}>
                    <div style={{ display: "flex", width: '100%', gridColumnGap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', gridColumnGap: '10px', gridRowGap: '10px', flexWrap: 'wrap' }}>

                            <DesktopDatePicker
                                label="From Date"
                                clearable
                                showTodayButton
                                inputFormat="DD/MM/YYYY"
                                size={'small'}
                                value={toDate}
                                onChange={(data) => setToDate(data)}
                                renderInput={(params) => <TextField sx={{ width: 170 }} size={'small'} {...params} />}
                            />
                            <DesktopDatePicker
                                label="To Date"
                                inputFormat="DD/MM/YYYY"
                                size={'small'}
                                value={fromDate}
                                onChange={(data) => setFromDate(data)}
                                renderInput={(params) => <TextField sx={{ width: 170 }} size={'small'} {...params} />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}

                                options={ibtDataFilter?.filter((item => item?.po_number !== '')).map((item => item?.po_number)).reduce((noDupArr, entry) => {
                                    if (noDupArr.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, [])}
                                onChange={(e, v) => setinvoiceNumberVal(v === null ? '' : v)}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Asn" />}
                            />

                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}

                                options={ibtDataFilter?.filter((item => item?.source !== '')).map((item => item?.source)).reduce((noDupArr, entry) => {
                                    if (noDupArr.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, [])}
                                onChange={(e, v) => setSource(v === null ? '' : v)}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Source" />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}

                                options={ibtDataFilter?.filter((item => item?.destination !== '')).map((item => item?.destination)).reduce((noDupArr, entry) => {
                                    if (noDupArr.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, [])}
                                onChange={(e, v) => setSource(v === null ? '' : v)}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Destination" />}
                            />


                        </div>

                        <button
                            onClick={() =>
                                searchData()
                                // fetchDataWithParams()
                            }
                            className="run-btn"><p className="run-text">Search</p></button>
                    </div>
                    <div style={{ marginTop: '20px', overflow: 'auto', height: '600px' }}>
                        <table data-table-theme="dark zebra">
                            <thead>
                                <tr style={{ background: "#373E43" }}>
                                    <th >ASN</th>
                                    <th>Source</th>
                                    <th>Destination</th>
                                    <th>Packed Qty</th>
                                    <th>Transfer Qty</th>
                                    <th>Received Qty </th>
                                    <th>Status </th>
                                    <th>Packing Date </th>
                                    <th>Shipping Date </th>
                                    <th>Receiving Date </th>
                                    <th>Packing Remarks </th>
                                    <th>Receiving Remarks </th>
                                    <th>Shipping Remarks </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ibtData.map((data, index) =>
                                        <tr>
                                            <td>{data?.po_number}|{data?.invoice_number}</td>
                                            <td>{data?.source}</td>
                                            <td>{data?.destination}</td>
                                            <td><NavLink to='/viewibtdetails' state={{ data: data?.items?.filter((item => item.process_status === 'packed')), asn: data?.po_number, date: data?.event_date }} >{data?.items?.filter((item => item.process_status === 'packed')).length}</NavLink></td>
                                            <td><NavLink to='/viewibtdetails' state={{ data: data?.items?.filter((item => item.process_status === 'shipped')) }} >{data?.items?.filter((item => item.process_status === 'shipped')).length}</NavLink></td>
                                            <td><NavLink to='/viewibtdetails' state={{ data: data?.items?.filter((item => item.process_status === 'received')), asn: data?.po_number }} >{data?.items?.filter((item => item.process_status === 'received')).length}</NavLink></td>
                                            <td>{data?.event_ref_id?.endsWith('01') ? 'packing' : data?.event_ref_id?.endsWith('02') ? 'shipping' : 'receiving'}</td>
                                            <td>{data?.packing_date}</td>
                                            <td>{data?.shipping_date}</td>
                                            <td>{data?.receiving_date}</td>
                                            <td>{data?.packing_remarks}</td>
                                            <td>{data?.receiving_remarks}</td>
                                            <td>{data?.shipping_remarks}</td>
                                            <td><div style={{ display: "flex", justifyContent: "space-between" }}>
                                                {data?.event_ref_id?.endsWith('01') ?
                                                    <div style={{ width: '150px', display: 'flex', justifyContent: 'center' }}>
                                                        <button className="action-btn" style={{ backgroundColor: "#E41119", border: "none", borderRadius: "10px" }}
                                                            onClick={() => deleteHandler(data)}>
                                                            <p className="action-txt">Delete</p>
                                                        </button>
                                                    </div>
                                                    : null
                                                }

                                            </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AsnCancelation;
